export default __webpack_public_path__ + "static/media/FbImg.a405038b.png";